"use strict";

var enhanceLunr = function enhanceLunr(lunr, lngs) {
  if (lngs.length) {
    require('lunr-languages/lunr.stemmer.support')(lunr);
    lngs.forEach(function (_ref) {
      var name = _ref.name;
      if (name !== 'en') {
        try {
          if (name === 'jp' || name === 'ja') {
            require("lunr-languages/tinyseg")(lunr);
          }
          require("lunr-languages/lunr.".concat(name))(lunr);
        } catch (e) {
          console.log(e);
        }
      }
    });
  }
};
module.exports = {
  enhanceLunr: enhanceLunr
};